import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
export function UrgencySection() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 24,
    minutes: 2,
    seconds: 29
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.hours === 0 && prev.minutes === 0 && prev.seconds === 0) {
          clearInterval(timer);
          return prev;
        }
        let newSeconds = prev.seconds - 1;
        let newMinutes = prev.minutes;
        let newHours = prev.hours;
        if (newSeconds < 0) {
          newSeconds = 59;
          newMinutes -= 1;
        }
        if (newMinutes < 0) {
          newMinutes = 59;
          newHours -= 1;
        }
        return {
          hours: newHours,
          minutes: newMinutes,
          seconds: newSeconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (time: number) => time.toString().padStart(2, '0');
  return <section className="w-full py-20 px-4 sm:px-6 lg:px-8 bg-[#1a0505] flex flex-col items-center" data-id="element-347">
      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} className="max-w-3xl w-full flex flex-col items-center text-center" data-id="element-348">
        <h2 className="text-lg sm:text-xl font-bold text-white mb-8 uppercase tracking-wide flex items-center gap-2" data-id="element-349">
          <span data-id="element-350">⏰</span> PRECIO DE LANZAMIENTO — CIERRA EN:
        </h2>

        <div className="flex items-start justify-center gap-2 sm:gap-4 mb-8" data-id="element-351">
          <div className="flex flex-col items-center" data-id="element-352">
            <span className="text-6xl sm:text-8xl font-black text-red-500 leading-none tracking-tighter" data-id="element-353">
              {formatTime(timeLeft.hours)}
            </span>
            <span className="text-gray-500 text-[10px] sm:text-xs font-bold mt-2 tracking-widest uppercase" data-id="element-354">
              HORAS
            </span>
          </div>

          <span className="text-5xl sm:text-7xl font-black text-red-500 leading-none mt-1 sm:mt-2" data-id="element-355">
            :
          </span>

          <div className="flex flex-col items-center" data-id="element-356">
            <span className="text-6xl sm:text-8xl font-black text-red-500 leading-none tracking-tighter" data-id="element-357">
              {formatTime(timeLeft.minutes)}
            </span>
            <span className="text-gray-500 text-[10px] sm:text-xs font-bold mt-2 tracking-widest uppercase" data-id="element-358">
              MIN
            </span>
          </div>

          <span className="text-5xl sm:text-7xl font-black text-red-500 leading-none mt-1 sm:mt-2" data-id="element-359">
            :
          </span>

          <div className="flex flex-col items-center" data-id="element-360">
            <span className="text-6xl sm:text-8xl font-black text-red-500 leading-none tracking-tighter" data-id="element-361">
              {formatTime(timeLeft.seconds)}
            </span>
            <span className="text-gray-500 text-[10px] sm:text-xs font-bold mt-2 tracking-widest uppercase" data-id="element-362">
              SEGUNDOS
            </span>
          </div>
        </div>

        <div className="text-white font-bold text-base sm:text-lg mb-12 flex items-center gap-2" data-id="element-363">
          <span data-id="element-364">⚠️</span> Después sube{' '}
          <span className="text-red-500" data-id="element-365">$15.000 ARS</span>. No vuelve.
        </div>

        <div className="w-full max-w-2xl" data-id="element-366">
          <div className="flex justify-between items-end mb-2 px-1" data-id="element-367">
            <div className="flex items-center gap-2 text-red-500 text-sm font-bold" data-id="element-368">
              <span className="w-3 h-3 rounded-full bg-red-500 animate-pulse" data-id="element-369"></span>
              Cupos al precio de lanzamiento
            </div>
            <div className="text-white text-sm font-bold" data-id="element-370">Quedan pocos</div>
          </div>

          <div className="h-4 w-full bg-[#2a303c] rounded-full overflow-hidden" data-id="element-371">
            <motion.div initial={{
            width: 0
          }} whileInView={{
            width: '68%'
          }} transition={{
            duration: 1.5,
            ease: 'easeOut'
          }} className="h-full rounded-full bg-gradient-to-r from-orange-500 to-red-600" data-id="element-372" />
          </div>

          <p className="text-gray-500 text-xs mt-3 text-right" data-id="element-373">
            68% de los cupos al precio de lanzamiento ya tomados
          </p>
        </div>
      </motion.div>
    </section>;
}